import { Loader } from '../../../components/loading/Loader';

export const LoaderBlock = () => {
  return (
    <div className='flex-1 bg-perception-black-800 relative'>
      <Loader category='transparent' />
    </div>
  );
};
